import { InputProps } from "@chakra-ui/react";
import React from "react";
import { UiInput, UiInputGroup, UiInputLeftElement, UiInputRightElement } from "~/components/elements";
import { EyeCloseIcon, EyeOpenIcon, LockIcon } from "~/components/icons/SvgIcons";

interface Props extends InputProps {
  buttonHideLabel?: string;
  buttonShowLabel?: string;
}

function PasswordInput({ ...rest }: Props) {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <UiInputGroup>
      <UiInputLeftElement pointerEvents="none">
        <LockIcon />
      </UiInputLeftElement>
      <UiInput type={showPassword ? "text" : "password"} placeholder="Enter your password" {...rest} ps="10" pe="10" />
      <UiInputRightElement _hover={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
        {showPassword ? <EyeOpenIcon /> : <EyeCloseIcon />}
      </UiInputRightElement>
    </UiInputGroup>
  );
}

export default PasswordInput;
